import * as jquery from "jquery";
import { Provider } from "mobx-react";
import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import MainLayout from "./pages/layouts/MainLayout";
import MobileLayout from "./mobile/pages/MobileLayout";
import FallBack from "./pages/layouts/partials/FallBack";
import RootStore from "./RootStore";
import { hasPermission } from "./utils/render-by-permission";
import { NoPermissionMessage } from "./components/permission";


Object.assign(global, {
  $: jquery,
  jQuery: jquery,
});

const LoginPage = React.lazy(() => import("./pages/LoginPage"));
const UserManagmentPage = React.lazy(() => import("./pages/UserManagmentPage"));
const UserFormPage = React.lazy(() => import("./pages/UserFormPage"));
const UserDetailPage = React.lazy(() => import("./pages/UserDetailPage"));
const RoleAndPermissionPage = React.lazy(
  () => import("./pages/RoleAndPermissionPage")
);
const OrgManagmentPage = React.lazy(() => import("./pages/OrgManagmentPage"));
const OrgFormPage = React.lazy(() => import("./pages/OrgFormPage"));
const DocRunningControlPage = React.lazy(
  () => import("./pages/DocRunningControlPage")
);
const DocRunningControlFormPage = React.lazy(
  () => import("./pages/DocRunningControlFormPage")
);
const OcupationListPage = React.lazy(() => import("./pages/OcupationListPage"));
const RequestListPage = React.lazy(() => import("./pages/RequestListPage"));
const RequestFormCreatePage = React.lazy(
  () => import("./pages/RequestFormCreatePage")
);
const RequestFormEditPage = React.lazy(
  () => import("./pages/RequestFormEditPage")
);
const RequestDetailPage = React.lazy(() => import("./pages/RequestDetailPage"));
const AgreementListPage = React.lazy(() => import("./pages/AgreementListPage"));
const AgreementFormCreatePage = React.lazy(
  () => import("./pages/AgreementFormCreatePage")
);
const AgreementDetailPage = React.lazy(
  () => import("./pages/AgreementDetailPage")
);
const AgreementFormEditPage = React.lazy(
  () => import("./pages/AgreementFormEditPage")
);

const GuaranteeListPage = React.lazy(() => import("./pages/GuaranteeListPage"));
const GuaranteeFormCreatePage = React.lazy(
  () => import("./pages/GuaranteeFormCreatePage")
);
const GuaranteeFormEditPage = React.lazy(
  () => import("./pages/GuaranteeFormEditPage")
);
const GuaranteeDetailPage = React.lazy(
  () => import("./pages/GuaranteeDetailPage")
);

const AccountReceivableListPage = React.lazy(
  () => import("./pages/AccountReceivableListPage")
);
const AccountReceivableDetailPage = React.lazy(
  () => import("./pages/AccountReceivableDetailPage")
);
const AccountReceivableFormEditPage = React.lazy(
  () => import("./pages/AccountReceivableFormEditPage")
);
const FinancialLoanPaymentPage = React.lazy(
  () => import("./pages/FinancialLoanPaymentPage")
);
const DonationAnalysisPage = React.lazy(
  () => import("./pages/DonationAnalysisPage")
);
const DonationAllowanceListPage = React.lazy(
  () => import("./pages/DonationAllowanceListPage")
);
const DonationDirectPage = React.lazy(
  () => import("./pages/DonationDirectPage")
);
const DonationDirectFormEditPage = React.lazy(
  () => import("./pages/DonationDirectFormEditPage")
);
const DonationAllowanceFormCreatePage = React.lazy(
  () => import("./pages/DonationAllowanceFormCreatePage")
);
const DonationAllowanceFormEditPage = React.lazy(
  () => import("./pages/DonationAllowanceFormEditPage")
);
const DebtCollectionListPage = React.lazy(
  () => import("./pages/DebtCollectionListPage")
);
const DebtCollectionDetailPage = React.lazy(
  () => import("./pages/DebtCollectionDetailPage")
);
const DebtCollectionEditPage = React.lazy(
  () => import("./pages/DebtCollectionEditPage")
);
const DebtCollectionLetterPage = React.lazy(
  () => import("./pages/DebtCollectionLetterPage")
);
const DebtCollectionLetterListPage = React.lazy(
  () => import("./pages/DebtCollectionLetterListPage")
);

const AccountReceiveableReportListPage = React.lazy(
  () => import("./pages/AccountReceiveableReportListPage")
);
const ReportCounterServicePage = React.lazy(
  () => import("./pages/ReportCounterServicePage")
);

const ReportKTBPage = React.lazy(() => import("./pages/ReportKTBPage"));

const DebtCollectionReportListPage = React.lazy(
  () => import("./pages/DebtCollectionReportListPage")
);
const DebtRepaymentReportListPage = React.lazy(
  () => import("./pages/DebtRepaymentReportListPage")
);
const DonationReportListPage = React.lazy(
  () => import("./pages/DonationReportListPage")
);

const BaacReportListPage = React.lazy(
  () => import("./pages/BaacReportListPage")
);

const DgaReportListPage = React.lazy(
  () => import("./pages/DgaReportListPage")
);

const ReceiptListPage = React.lazy(() => import("./pages/ReceiptListPage"));
const PosListPage = React.lazy(() => import("./pages/PosListPage"));
const PosManagementDetailPage = React.lazy(
  () => import("./pages/PosManagementDetailPage")
);
const PosLoginPage = React.lazy(() => import("./pages/PosLoginPage"));
const PosCashierPage = React.lazy(() => import("./pages/PosCashierPage"));
const ReceiptControlListPage = React.lazy(
  () => import("./pages/ReceiptControlListPage")
);

// DANG: Add Meeting Documents Page
const MeetingDocumentsMinutesPage = React.lazy(
  () => import("./pages/MeetingDocumentsMinutesPage")
);

// DANG: Add Receipt Used Page
const ReceiptUsedReportPage = React.lazy(
  () => import("./pages/ReceiptUsedReportPage")
);

const MeetingDocumentsResolutionPage = React.lazy(
  () => import("./pages/MeetingDocumentsResolutionPage")
);
// const TestPage = React.lazy(() => import("./pages/TestPage"));

const DashboardPage = React.lazy(
  () => import("./pages/DashboardPage")
);

// DGA: Mobile Component
const MobileLoginPage = React.lazy(() => import("./mobile/pages/MobileLoginPage"));
const MobileMainPage = React.lazy(() => import("./mobile/pages/MobileMainPage"));
const MobileOdfInfoPage = React.lazy(() => import("./mobile/pages/MobileOdfInfoPage"));
const MobileAgreementDetailPage = React.lazy(() => import("./mobile/pages/MobileAgreementDetail"));
const MobileRequestDetailPage = React.lazy(() => import("./mobile/pages/MobileRequestDetail"));
const MobileGuarantorDetailPage = React.lazy(() => import("./mobile/pages/MobileGuarantorDetail"));
const MobilePaymentPage = React.lazy(() => import("./mobile/pages/MobilePaymentPage"));
const OriginRequestFormEditPage = React.lazy(() => import("./mobile/origin-pages/RequestFormEditPage"));
const OriginRequestDetailPage = React.lazy(() => import("./mobile/origin-pages/RequestDetailPage"));
const OriginRequestFormCreatePage = React.lazy(() => import("./mobile/origin-pages/RequestFormCreatePage"));



require("./../node_modules/semantic-ui-calendar/dist/calendar.min.js");
require("./../node_modules/semantic-ui-calendar/dist/calendar.min.css");
require("./semantic/semantic.ui.popup.js");
require("./semantic/semantic.ui.transition.js");

class App extends Component {
  public render() {
    return (
      <FallBack inverted={true}>
        <Provider {...RootStore}>
          <BrowserRouter>
            <Switch>         
              <Route exact path="/mobile/login" component={MobileLoginPage} />        
              <Route path='/mobile/*' exact >
                <MobileLayout>
                  <Route exact path="/mobile/login" component={MobileLoginPage} />        
                  <Route 
                    exact 
                    path="/mobile" 
                    render={(props: any) =>
                    this.renderComponentMorePermission(
                      <MobileMainPage {...props} />,
                      ["REQUEST.ACCESS", "REQUEST.ONLINE.ACCESS"]
                    )
                  }
                  />  
                  <Route 
                    exact 
                    path="/mobile/main" 
                    render={(props: any) =>
                    this.renderComponentMorePermission(
                      <MobileMainPage {...props} />,
                      ["REQUEST.ACCESS", "REQUEST.ONLINE.ACCESS"]
                    )
                  }
                  />                   
                  <Route 
                    exact 
                    path="/mobile/odf_info" 
                    render={(props: any) =>
                    this.renderComponentMorePermission(
                      <MobileOdfInfoPage {...props} />,
                      ["REQUEST.ACCESS", "REQUEST.ONLINE.ACCESS"]
                    )
                  }
                  />                                   
                  <Route 
                    exact 
                    path="/mobile/account_receivable/:id" 
                    render={(props: any) =>
                    this.renderComponentMorePermission(
                      <MobileAgreementDetailPage {...props} />,
                      ["REQUEST.ACCESS", "REQUEST.ONLINE.ACCESS"]
                    )
                  }
                  />          
                  <Route
                    exact
                    path="/mobile/request_create"
                    render={(props: any) =>
                      this.renderComponentMorePermission(
                        <OriginRequestFormCreatePage {...props} />,
                        ["REQUEST.EDIT", "REQUEST.ONLINE.EDIT", "DATA.ALL.EDIT"]
                      )
                    }
                  />                                                                               
                  <Route 
                    exact 
                    path="/mobile/request/:id" 
                    render={(props: any) =>
                    this.renderComponentMorePermission(
                      <MobileRequestDetailPage {...props} />,
                      ["REQUEST.ACCESS", "REQUEST.ONLINE.ACCESS"]
                    )
                  }
                  />         
                  <Route 
                    exact 
                    path="/mobile/guarantor/:id/:name" 
                    render={(props: any) =>
                    this.renderComponentMorePermission(
                      <MobileGuarantorDetailPage {...props} />,
                      ["REQUEST.ACCESS", "REQUEST.ONLINE.ACCESS"]
                    )
                  }
                  />                               
                <Route
                  path="/mobile/request/view/:id/:name"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <OriginRequestDetailPage {...props} />,
                      ["REQUEST.VIEW", "REQUEST.ONLINE.VIEW", "DATA.ALL.EDIT"]
                    )
                  }
                />

                <Route
                  path="/mobile/request/edit/:id/:name"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <OriginRequestFormEditPage {...props} />,
                      ["REQUEST.EDIT", "REQUEST.ONLINE.EDIT", "DATA.ALL.EDIT"]
                    )
                  }
                />                  
                <Route
                  path="/mobile/payment/:id/:name"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <MobilePaymentPage {...props} />,
                      ["REQUEST.EDIT", "REQUEST.ONLINE.EDIT", "DATA.ALL.EDIT"]
                    )
                  }
                />                  

                </MobileLayout>                    
              </Route>

            <Route exact path="/login" component={LoginPage} />              
              <MainLayout>
                <Route
                  exact
                  path="/"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <RequestListPage {...props} />,
                      ["REQUEST.ACCESS", "REQUEST.ONLINE.ACCESS"]
                    )
                  }
                />
                {/* /////// User ////// */}
                <Route
                  exact
                  path="/admin/user_managment"
                  render={(props: any) =>
                    this.renderComponent(
                      <UserManagmentPage {...props} />,
                      "USER.ACCESS"
                    )
                  }
                />
                <Route
                  path="/admin/user_managment/create"
                  render={(props: any) =>
                    this.renderComponent(
                      <UserFormPage {...props} />,
                      "USER.CREATE"
                    )
                  }
                />
                <Route
                  path="/admin/user_managment/edit/:id/:name"
                  render={(props: any) =>
                    this.renderComponent(
                      <UserFormPage {...props} />,
                      "USER.EDIT"
                    )
                  }
                />
                <Route
                  path="/admin/user_managment/view/:id/:name"
                  render={(props: any) =>
                    this.renderComponent(
                      <UserDetailPage {...props} />,
                      "USER.VIEW"
                    )
                  }
                />

                {/* /////// Role & Permission ////// */}
                <Route
                  path="/admin/role_permission"
                  render={(props: any) =>
                    this.renderComponent(
                      <RoleAndPermissionPage {...props} />,
                      "ROLE.ACCESS"
                    )
                  }
                />

                {/* /////// Organization ////// */}
                <Route
                  exact
                  path="/admin/org_management"
                  render={(props: any) =>
                    this.renderComponent(
                      <OrgManagmentPage {...props} />,
                      "ORG.ACCESS"
                    )
                  }
                />
                <Route
                  path="/admin/org_management/create"
                  render={(props: any) =>
                    this.renderComponent(
                      <OrgFormPage {...props} />,
                      "ORG.CREATE"
                    )
                  }
                />
                <Route
                  path="/admin/org_management/edit/:id/:name"
                  render={(props: any) =>
                    this.renderComponent(<OrgFormPage {...props} />, "ORG.EDIT")
                  }
                />

                {/* /////// Document Control ////// */}
                <Route
                  exact
                  path="/admin/doc_control"
                  render={(props: any) =>
                    this.renderComponent(
                      <DocRunningControlPage {...props} />,
                      "DOC.ACCESS"
                    )
                  }
                />
                <Route
                  path="/admin/doc_control/create"
                  render={(props: any) =>
                    this.renderComponent(
                      <DocRunningControlFormPage {...props} />,
                      "DOC.CREATE"
                    )
                  }
                />
                <Route
                  path="/admin/doc_control/edit/:id/:sequencetype"
                  render={(props: any) =>
                    this.renderComponent(
                      <DocRunningControlFormPage {...props} />,
                      "DOC.EDIT"
                    )
                  }
                />

                {/* /////// Ocupation List ////// */}
                <Route
                  exact
                  path="/admin/ocupation"
                  render={(props: any) =>
                    this.renderComponent(
                      <OcupationListPage {...props} />,
                      "OCCUPATION.ACCESS"
                    )
                  }
                />

                {/* /////// Request List ////// */}
                <Route
                  exact
                  path="/loan/request"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <RequestListPage {...props} />,
                      ["REQUEST.ACCESS", "REQUEST.ONLINE.ACCESS"]
                    )
                  }
                />
                <Route
                  exact
                  path="/loan/request/create"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <RequestFormCreatePage {...props} />,
                      ["REQUEST.CREATE", "REQUEST.ONLINE.CREATE"]
                    )
                  }
                />
                <Route
                  path="/loan/request/view/:id/:name"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <RequestDetailPage {...props} />,
                      ["REQUEST.VIEW", "REQUEST.ONLINE.VIEW", "DATA.ALL.EDIT"]
                    )
                  }
                />

                <Route
                  path="/loan/request/edit/:id/:name"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <RequestFormEditPage {...props} />,
                      ["REQUEST.EDIT", "REQUEST.ONLINE.EDIT", "DATA.ALL.EDIT"]
                    )
                  }
                />

                {/* /////// Agreement List ////// */}
                <Route
                  exact
                  path="/loan/agreement"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <AgreementListPage {...props} />,
                      ["AGREEMENT.ACCESS"]
                    )
                  }
                />
                <Route
                  path="/loan/agreement/create"
                  render={(props: any) =>
                    this.renderComponent(
                      <AgreementFormCreatePage {...props} />,
                      "AGREEMENT.CREATE"
                    )
                  }
                />

                <Route
                  path="/loan/agreement/view/:id/:name"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <AgreementDetailPage {...props} />,
                      ["AGREEMENT.VIEW", "DATA.ALL.EDIT"]
                    )
                  }
                />
                <Route
                  path="/loan/agreement/edit/:id/:name"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <AgreementFormEditPage {...props} />,
                      ["AGREEMENT.EDIT", "DATA.ALL.EDIT", "AGREEMENT.EDIT.PREPARE","AGREEMENT.UPLOAD"]
                    )
                  }
                />

                {/* /////// Guarantee List ////// */}
                <Route
                  exact
                  path="/loan/guarantee"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <GuaranteeListPage {...props} />,
                      ["GUANRANTEE.ACCESS"]
                    )
                  }
                />
                <Route
                  path="/loan/guarantee/create"
                  render={(props: any) =>
                    this.renderComponent(
                      <GuaranteeFormCreatePage {...props} />,
                      "GUANRANTEE.CREATE"
                    )
                  }
                />
                <Route
                  path="/loan/guarantee/view/:id"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <GuaranteeDetailPage {...props} />,
                      ["GUANRANTEE.VIEW", "DATA.ALL.EDIT"]
                    )
                  }
                />
                <Route
                  path="/loan/guarantee/edit/:id"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <GuaranteeFormEditPage {...props} />,
                      ["GUANRANTEE.EDIT", "DATA.ALL.EDIT", "GUANRANTEE.EDIT.PREPARE"]
                    )
                  }
                />

                {/* /////// AccountReceivable List ////// */}
                <Route
                  exact
                  path="/account_receivable"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <AccountReceivableListPage {...props} />,
                      ["AR.ACCESS", "REQUEST.ONLINE.ACCESS"]
                    )
                  }
                />
                <Route
                  path="/account_receivable/view/:id/:name"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <AccountReceivableDetailPage {...props} />,
                      ["AR.VIEW", "REQUEST.ONLINE.ACCESS"]
                    )
                  }
                />
                <Route
                  path="/account_receivable/edit/:id/:name"
                  render={(props: any) =>
                    this.renderComponent(
                      <AccountReceivableFormEditPage {...props} />,
                      "AR.EDIT"
                    )
                  }
                />

                {/*  Financial */}
                <Route
                  path="/finance/loan_payment"
                  render={(props: any) =>
                    this.renderComponent(
                      <FinancialLoanPaymentPage {...props} />,
                      "VOUCHER.ACCESS"
                    )
                  }
                />
                {/*  Donation */}
                <Route
                  exact
                  path="/donation/allowances"
                  render={(props: any) =>
                    this.renderComponent(
                      <DonationAllowanceListPage {...props} />,
                      "DONATE.ALLOWANCE.ACCESS"
                    )
                  }
                />
                <Route
                  path="/donation/allowances/create"
                  render={(props: any) =>
                    this.renderComponent(
                      <DonationAllowanceFormCreatePage {...props} />,
                      "DONATE.ALLOWANCE.ACCESS"
                    )
                  }
                />
                <Route
                  path="/donation/allowances/edit/:id/:name"
                  render={(props: any) =>
                    this.renderComponent(
                      <DonationAllowanceFormEditPage {...props} />,
                      "DONATE.ALLOWANCE.ACCESS"
                    )
                  }
                />
                <Route
                  exact
                  path="/donation/directs"
                  render={(props: any) =>
                    this.renderComponent(
                      <DonationDirectPage {...props} />,
                      "DONATE.DIRECT.ACCESS"
                    )
                  }
                />
                <Route
                  path="/donation/directs/edit/:id"
                  render={(props: any) =>
                    this.renderComponent(
                      <DonationDirectFormEditPage {...props} />,
                      "DONATE.DIRECT.ACCESS"
                    )
                  }
                />
                <Route
                  path="/donation/analysis"
                  render={(props: any) =>
                    this.renderComponent(
                      <DonationAnalysisPage {...props} />,
                      "DONATE.ANALYSIS.ACCESS"
                    )
                  }
                />

                {/*  DebtCollection */}
                <Route
                  exact
                  path="/debtCollection/list"
                  render={(props: any) =>
                    this.renderComponent(
                      <DebtCollectionListPage {...props} />,
                      "DEBTCOLLECTION.ACCESS"
                    )
                  }
                />
                <Route
                  path="/debtCollection/view/:id"
                  render={(props: any) =>
                    this.renderComponent(
                      <DebtCollectionDetailPage {...props} />,
                      "DEBTCOLLECTION.VIEW"
                    )
                  }
                />
                <Route
                  path="/debtCollection/edit/:id"
                  render={(props: any) =>
                    this.renderComponent(
                      <DebtCollectionEditPage {...props} />,
                      "DEBTCOLLECTION.EDIT"
                    )
                  }
                />
                <Route
                  exact
                  path="/debtCollection/create_letter"
                  render={(props: any) =>
                    this.renderComponent(
                      <DebtCollectionLetterPage {...props} />,
                      "DEBTCOLLECTION.ACCESS"
                    )
                  }
                />
                <Route
                  exact
                  path="/debtCollection/search_letter"
                  render={(props: any) =>
                    this.renderComponent(
                      <DebtCollectionLetterListPage {...props} />,
                      "DEBTCOLLECTION.ACCESS"
                    )
                  }
                />

                {/*  Reports */}
                <Route
                  path="/reports/accountReceiveable"
                  render={(props: any) =>
                    this.renderComponent(
                      <AccountReceiveableReportListPage {...props} />,
                      "REPORT.AR.ACESS"
                    )
                  }
                />
                <Route
                  path="/reports/counterService"
                  render={(props: any) =>
                    this.renderComponent(
                      <ReportCounterServicePage {...props} />,
                      "REPORT.CS.ACCESS"
                    )
                  }
                />
                <Route
                  path="/reports/ktb"
                  render={(props: any) =>
                    this.renderComponent(
                      <ReportKTBPage {...props} />,
                      "REPORT.KTB.ACCESS"
                    )
                  }
                />
                <Route
                  path="/reports/debt_collection"
                  render={(props: any) =>
                    this.renderComponent(
                      <DebtCollectionReportListPage {...props} />,
                      "REPORT.DEBTCOLLECTION.ACCESS"
                    )
                  }
                />
                <Route
                  path="/reports/debtRepayment"
                  render={(props: any) =>
                    this.renderComponent(
                      <DebtRepaymentReportListPage {...props} />,
                      "REPORT.POS.RECIEPT.ACCESS"
                    )
                  }
                />
                <Route
                  path="/reports/donation"
                  render={(props: any) =>
                    this.renderComponent(
                      <DonationReportListPage {...props} />,
                      "REPORT.DONATE.ACCESS"
                    )
                  }
                />

                <Route
                  path="/reports/baac"
                  render={(props: any) =>
                    this.renderComponent(
                      <BaacReportListPage {...props} />,
                      "REPORT.BAAC.ACCESS"
                    )
                  }
                />
                <Route
                  path="/reports/dga"
                  render={(props: any) =>
                    this.renderComponent(
                      <DgaReportListPage {...props} />,
                      "REPORT.DGA.ACCESS"
                    )
                  }
                />                
                {/*  POS */}

                <Route
                  exact
                  path="/pos/receipt_payment"
                  render={(props: any) =>
                    this.renderComponent(
                      <ReceiptListPage {...props} />,
                      "POS.RECEIPTS.ACCESS"
                    )
                  }
                />
                <Route
                  exact
                  path="/pos/management"
                  render={(props: any) =>
                    this.renderComponent(
                      <PosListPage {...props} />,
                      "POS.ACCESS"
                    )
                  }
                />
                <Route
                  exact
                  path="/pos/management/create"
                  render={(props: any) =>
                    this.renderComponent(
                      <PosManagementDetailPage {...props} />,
                      "POS.CREATE"
                    )
                  }
                />
                <Route
                  exact
                  path="/pos/management/edit/:id"
                  render={(props: any) =>
                    this.renderComponent(
                      <PosManagementDetailPage {...props} />,
                      "POS.EDIT"
                    )
                  }
                />
                <Route
                  exact
                  path="/pos/cashier"
                  render={(props: any) =>
                    this.renderComponent(
                      <PosLoginPage {...props} />,
                      "POS.USAGE.ACCESS"
                    )
                  }
                />
                <Route
                  path="/pos/cashier/:id"
                  render={(props: any) =>
                    this.renderComponent(
                      <PosCashierPage {...props} />,
                      "POS.USAGE.ACCESS"
                    )
                  }
                />

                <Route
                  path="/pos/receipt_control"
                  render={(props: any) =>
                    this.renderComponent(
                      <ReceiptControlListPage {...props} />,
                      "POS.RECEIPTCONTROLS.ACCESS"
                    )
                  }
                />

                {/* /////// DANG: Meeting Documents List ////// */}
                <Route
                  exact
                  path="/meeting_documents/minutes"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <MeetingDocumentsMinutesPage {...props} />,
                      ["MINUTES.ACCESS"]
                    )
                  }
                />

                <Route
                  exact
                  path="/meeting_documents/resolution"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <MeetingDocumentsResolutionPage {...props} />,
                      ["RESOLUTION.ACCESS"]
                    )
                  }
                />

                <Route
                  exact
                  path="/receipt_used"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <ReceiptUsedReportPage {...props} />,
                      ["RESOLUTION.ACCESS"]

                    )
                  }
                />

                <Route
                  exact
                  path="/dashboard"
                  render={(props: any) =>
                    this.renderComponentMorePermission(
                      <DashboardPage {...props} />,
                      ["DASHBOARD.VIEW"]
                    )
                  }
                />
                {/* DGA: Mobile View Support /> */}

                {/* <Route exact path="/test" component={TestPage} /> */}
              </MainLayout>
            </Switch>
          </BrowserRouter>
        </Provider>
      </FallBack>
    );
  }

  private renderComponent = (component: any, code: string) => {
    if (hasPermission(code)) {
      return component;
    } else {
      return <NoPermissionMessage />;
    }
  };
  private renderComponentMorePermission = (component: any, codes: string[]) => {    
    if (codes.some((code: string) => hasPermission(code))) {
      return component;
    } else {
      return <NoPermissionMessage />;
    }
  };
}
export default App;
